import { render, staticRenderFns } from "./IconLive.vue?vue&type=template&id=07732cb4&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07732cb4')) {
      api.createRecord('07732cb4', component.options)
    } else {
      api.reload('07732cb4', component.options)
    }
    module.hot.accept("./IconLive.vue?vue&type=template&id=07732cb4&", function () {
      api.rerender('07732cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/IconLive.vue"
export default component.exports